import React, { FC } from 'react';
import { Modal, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Table } from '~/components';
import { ExpiredDocument } from '~/utils/getExpiredDocuments';

interface Props {
  visible: boolean;
  expiredDocuments: ExpiredDocument[];
  onOk: () => void;
}

const ExpiredDocumentsModal: FC<Props> = ({ visible, expiredDocuments, onOk }) => {
  const { t } = useTranslation();

  const columns = [
    { title: t('Contact Type'), dataIndex: 'contactType', key: 'contactType' },
    { title: t('Name'), dataIndex: 'contactName', key: 'contactName' },
    { title: t('Document'), dataIndex: 'documentType', key: 'documentType' },
    { title: t('Expiry Date'), dataIndex: 'expiryDate', key: 'expiryDate' },
  ];

  return (
    <StyledModal
      visible={visible}
      centered
      closable={false}
      maskClosable={false}
      okText={t('OK')}
      onOk={onOk}
      cancelButtonProps={{ style: { display: 'none' } }}
      title={t('Expired Documents')}
      width={720}
    >
      <Typography.Paragraph>
        {t('The following documents have expired. Please review the details below.')}
      </Typography.Paragraph>
      <Table
        id="expiredDocumentsTable"
        columns={columns}
        dataSource={expiredDocuments}
        rowKey={(record: ExpiredDocument, index?: number) =>
          `${record.contactType}-${record.contactName}-${record.documentType}-${index}`
        }
        pagination={false}
        scroll={{ y: 320 }}
      />
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  .ant-modal-body {
    padding-top: 12px;
  }
`;

export default ExpiredDocumentsModal;
